import { DateTimeFilter } from '@/@generated/codegen/API';

export const parseDateQueryParam = (date: string | undefined): DateTimeFilter | undefined => {
  if (!date) {
    return undefined;
  }

  const dateTimeFilter: DateTimeFilter = {};

  const greaterThanMatch = date.match(/^\+(\d{13})$/);
  const lessThanMatch = date.match(/^-(\d{13})$/);
  const rangeMatch = date.match(/^(\d{13})-(\d{13})$/);

  if (greaterThanMatch) {
    dateTimeFilter.gte = new Date(parseInt(greaterThanMatch[1], 10));
  } else if (lessThanMatch) {
    dateTimeFilter.lte = new Date(parseInt(lessThanMatch[1], 10));
  } else if (rangeMatch) {
    dateTimeFilter.gte = new Date(parseInt(rangeMatch[1], 10));
    dateTimeFilter.lte = new Date(parseInt(rangeMatch[2], 10));
  }

  console.log('DEBUG >> dateTimeFilter', dateTimeFilter);

  return Object.keys(dateTimeFilter).length ? dateTimeFilter : undefined;
};
